import { useState, useCallback } from 'react'
import type { Product, CartItem } from '@/types'

export function useCart() {
  const [items, setItems] = useState<CartItem[]>([])

  const addItem = useCallback((product: Product) => {
    const cartId = `${product.id}-${Date.now()}`
    setItems(prev => [...prev, { ...product, cartId }])
  }, [])

  const removeItem = useCallback((cartId: string) => {
    setItems(prev => prev.filter(i => i.cartId !== cartId))
  }, [])

  const clearCart = useCallback(() => setItems([]), [])

  const total = items.reduce((sum, item) => sum + item.price, 0)

  return { items, addItem, removeItem, clearCart, total }
}
